export const ProgressRing = ({
  progress,
  size = 40,
}: {
  progress: number;
  size?: number;
}) => {
  const radius = 16;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;
  const center = size / 2;

  return (
    <svg
      className="absolute inset-0"
      width={size}
      height={size}
      style={{ transform: "rotate(-90deg)" }}
    >
      <circle
        className="text-gray-200"
        stroke="currentColor"
        strokeWidth={2}
        fill="transparent"
        r={radius}
        cx={center}
        cy={center}
      />
      <circle
        className="text-red-500 transition-all duration-100"
        stroke="currentColor"
        strokeWidth={2}
        fill="transparent"
        r={radius}
        cx={center}
        cy={center}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
      />
    </svg>
  );
};
